
import { useProfileData } from "./profile/useProfileData";
import { usePasswordManagement } from "./profile/usePasswordManagement";
import { useToast } from "@/components/ui/use-toast";

export type { ProfileData } from "./profile/useProfileData";

export const useProfileManagement = () => {
  const { toast } = useToast();
  const {
    profile,
    loading,
    saving,
    setProfile,
    fetchProfile,
    updateProfile,
  } = useProfileData();

  const {
    currentPassword,
    newPassword,
    confirmPassword,
    setCurrentPassword,
    setNewPassword,
    setConfirmPassword,
    updatePassword,
    resetPassword,
  } = usePasswordManagement(profile?.id || "");

  const handleProfileUpdate = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!profile) return;

    try {
      const profileUpdated = await updateProfile(profile);
      if (!profileUpdated) {
        throw new Error("Failed to update profile");
      }

      if (newPassword) {
        const passwordUpdated = await updatePassword();
        if (!passwordUpdated) {
          // Password update already shows its own error messages
          return;
        }
      }

      toast({
        title: "Success",
        description: "Profile updated successfully",
      });
    } catch (error) {
      console.error('Error in handleProfileUpdate:', error);
      toast({
        title: "Error",
        description: "Failed to update profile",
        variant: "destructive",
      });
    }
  };

  return {
    profile,
    loading,
    saving,
    currentPassword,
    newPassword,
    confirmPassword,
    setProfile,
    setCurrentPassword,
    setNewPassword,
    setConfirmPassword,
    fetchProfile,
    handleProfileUpdate,
    resetPassword,
  };
};
